import React, { useState } from 'react';
import { Grid, Tabs, Tab } from '@mui/material';
import { BatchReports } from './reports/BatchReports';

const REPORTS_TABS = [
    'Batch',
    'Month',
    'Project',
    'BCR',
    'ISO'
]

export default function RofReports({ next, totalItems, active, projectId, projectKey }) {
    const [selectedTab, setSelectedTab] = useState('Batch');
    const handleChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    return (
        <Grid container gap={3}>
            <Grid item sx={{ display: 'flex', width: '100%' }}>
                <Tabs value={selectedTab} onChange={handleChange}>
                    {REPORTS_TABS.map((tab) => (
                        <Tab
                            key={tab}
                            value={tab}
                            label={tab}
                            disabled={tab !== 'Batch'}
                        />
                    ))}
                </Tabs>
            </Grid>
            {
                selectedTab === 'Batch' &&
                <BatchReports
                    next={next}
                    totalItems={totalItems}
                    active={active}
                    projectId={projectId}
                    projectKey={projectKey} />
            }
        </Grid>
    )
}